import { Button } from "./Button";
/**
 * Сегментированный переключатель — один выбранный вариант из нескольких.
 * Используется для смены режима просмотра (2D / 3D).
 */
import type { ReactNode } from "react";

interface Option<T extends string | number> {
	value: T;
	label: string;
	icon?: ReactNode;
	disabled?: boolean;
	title?: string;
}

interface Props<T extends string | number> {
	className?: string;
	value: T;
	options: Option<T>[];
	onChange: (value: T) => void;
}

export const SegmentedControl = <T extends string | number>({
	className = "",
	value,
	options,
	onChange,
}: Props<T>) => {
	return (
		<div
			className={`flex shrink-0 overflow-hidden rounded-2xl border border-border bg-accent-soft p-px ${className}`}
			role="group"
		>
			{options.map((option) => (
				<Button
					key={option.value}
					type="button"
					border={false}
					variant="segmented"
					active={option.value === value}
					aria-pressed={option.value === value}
					className="flex h-6 flex-1 items-center justify-center gap-0.5 rounded-none border-r border-border px-3 py-2 text-xs font-medium transition-colors duration-150 first:rounded-l-2xl last:rounded-r-2xl last:border-r-0 disabled:cursor-not-allowed disabled:opacity-45"
					disabled={option.disabled}
					title={option.title ?? option.label}
					onClick={() => onChange(option.value)}
				>
					{option.icon && (
						<span className="flex items-center" aria-hidden>
							{option.icon}
						</span>
					)}
					{option.label}
				</Button>
			))}
		</div>
	);
};
